import { SxProps, Theme } from '@mui/material/styles';

import { colors } from '../UI/colors';

export const reasonForVisitStyles = {
  reasonSelectButton: {
    height: '40px',
    justifyContent: 'space-between',
    display: 'flex',
    padding: '14px 32px'
  } as SxProps<Theme>,

  reasonMenuPaper: {
    marginTop: '0.5rem',
    borderRadius: '0.75rem !important',
    padding: '0.5rem',
  } as SxProps<Theme>,

  reasonMenuList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  } as SxProps<Theme>,

  reasonMenuItem: {
    padding: '0.5rem',
    gap: '0.5rem',
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    "@media (min-width:600px)": {
      fontSize: "1rem",
      lineHeight: "1.5em",
    },
    "@media (min-width:960px)": {
      fontSize: "1.125rem",
      lineHeight: "1.5rem",
    },
    color: colors.text.primary,
    borderRadius: '0.5rem',
  } as SxProps<Theme>,

  reasonMenuItemSelected: {
    borderRadius: '0.5rem',
    border: '2px solid #282828',
    backgroundColor: 'white',
  } as SxProps<Theme>,

  reasonPlaceholder: {
    color: '#999',
  } as SxProps<Theme>,

  reasonForVisitIcon: {
    borderRadius: '0.375rem',
    width: '2.25rem',
    height: '2.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as SxProps<Theme>,

  reasonForVisitIconDentures: {
    background: '#D7EDFF',
  } as SxProps<Theme>,

  reasonForVisitIconDentalImplants: {
    background: '#D7EDFF',
  } as SxProps<Theme>,

  reasonForVisitIconMotto: {
    background: '#DEF4F4',
  } as SxProps<Theme>,

  reasonForVisitIconEmergency: {
    background: '#FFEAEB',
  } as SxProps<Theme>,

  reasonForVisitIconBrokenTooth: {
    background: '#E5EDF8',
  } as SxProps<Theme>,

  reasonForVisitIconOtherCheckup: {
    background: '#E5EDF8',
  } as SxProps<Theme>,
};